module.exports = __webpack_public_path__ + "img/Risk-assessment.9a109ec3.png";